














































































































































import { Component, Provide, Watch, Vue, Prop } from "vue-property-decorator";
import ServiceSelect from "./ServiceSelect.vue";
import Service from "../models/service";
import CatalogService from "../models/catalog.service";
import Bill from "../models/bill";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import { EventBus } from "@/event-bus";

@Component({
  components: {
    "service-select": ServiceSelect
  },
  props: ["servicesCatalog", "services", "bills", "patientId", "patientCreateDate", "files"]
})
export default class Edit extends Vue {
  @Provide()
  parentValidator = this.$validator;
  moment = moment;

  @Prop()
  services: any;
  
  @Prop()
  bills!: Bill[];
  
  @Prop()
  patientId: any;

  @Prop()
  patientCreateDate: any;

  @Prop()
  servicesCatalog: any;

  @Prop()
  files: any;
  
  donors: any = [];

  paymentTypes: any = [];

  billServices: any = [];

  complexServices: any = [];

  bill: any = null;

  form = {
    billDate: "",
    billNumber: "",
    billPaymentType: "",
    donorId: ""
  } as any;   

  @Watch("patientId")
  onPatientIdChanged(val: string, oldVal: string) {
    if(!oldVal && val)
    {
      this.refreshDonors();
    }    
  }

  refreshDonors() {
    EventBus.$emit("showThrobber");
    axios
      .get("/Dictionary/GetPatientDonors?patientId=" + this.patientId)
      .then((response) => {
        this.donors = response.data;
        EventBus.$emit("hideThrobber");
      })
      .catch(() => {
        EventBus.$emit("hideThrobber");
      });
  }

  userHasFunction(name: any) {
    return (
      this.$auth.user().functions.find(
        (t: any) => t.routeName === name
      ) != null
    );
  }

  serviceAddHandler(catalogService: CatalogService) {    
    this.services.push(new Service(catalogService));
    this.$emit("updateServices", this.services);
  }

  createBillHandler() {    
    if (this.servicesForBill.length > 0) {
      for(let i = 0; i < this.servicesForBill.length; i++) {
        if(!this.servicesForBill[i].price || this.servicesForBill[i].price <= 0) {
          Swal(
            this.$t('Формирование счета') + '',
            this.$t('Необходимо указать корректую цену всех услуг') + '',
            "info"
          );  
          return;  
        }
      }
      EventBus.$emit("showThrobber");
      axios.get("/Dictionary/GetPaymentTypes").then(response => {
        this.paymentTypes = response.data;
        EventBus.$emit("hideThrobber");
        this.showModal("bill-modal");
      });      
    } else {
      Swal(
        this.$t('Формирование счета') + '',
        this.$t('Необходимо добавить услуги и выставить признак `выбрана`') + '',
        "info"
      );
    }
  }

  getServiceType(ser :any) {        
    return this.servicesCatalog.find((service: any) => service.id == ser.serviceId).sectionName;
  }

  get servicesForBill() {
    return this.services.filter(
      (service: Service) => !service.billId && service.isChecked
    );
  }

  showModal(modal: any) {
    this.$root.$emit("bv::show::modal", modal);
  }

  hideModal(modal: any) {
    this.$root.$emit("bv::hide::modal", modal);
  }


  hideComplexServiceModal(){
    this.hideModal('view-complex-service-modal');
    this.showModal('view-bill-modal');
  }  

  async handleCreateBill() {
    this.$validator.validateAll().then((result: any) => { 
      if(!result) 
      {
        return;
      }

        let bill: Bill = new Bill(this.paymentTypes);
        bill.date = this.form.billDate;
        bill.number = this.form.billNumber;
        bill.paymentType = this.form.billPaymentType;
        bill.paymentTypeName = this.paymentTypes.find((t: any) => t.key == bill.paymentType).value;
        bill.donorId = this.form.donorId;
        if(this.form.donorId)
        {
          bill.donorIdd = this.donors.find((t: any) => t.key == bill.donorId).value;
        }      

        this.servicesForBill.forEach((service: Service) => {
          if (!service.billId && service.isChecked) {
            service.bill = bill;
            service.billId = bill.id;
            bill.price += service.price;
          }
        });

        this.bills.push(bill);
        this.$emit("updateBills", this.bills);
        this.$emit("updateServices", this.services);
        this.$emit("createBill");
        this.hideModal("bill-modal");      
    });        
  }

  removeBillHandler(bill: Bill) {
    const services = this.services.filter(
      (service: Service) => service.billId == bill.id
    );

    services.forEach((service: Service) => {
      service.billId = undefined;
    });

    this.bills.splice(this.bills.indexOf(bill), 1);
    this.$emit("updateBills", this.bills);
    this.$emit("updateServices", this.services);
  }

  viewBillHandler(bill: Bill) {
    this.bill = bill;
    if(this.bill && this.bill.id) {
      this.billServices = this.services.filter((t: any) => t.billId == this.bill.id);
    } else {
      this.billServices = this.servicesForBill;
    }

    this.showModal("view-bill-modal");
  }

  viewComplexServices(service: Service) {
    EventBus.$emit("showThrobber");
      axios.get(`/Services/AllForComplexService/${service.id}`).then(response => {
        this.complexServices = response.data;
        EventBus.$emit("hideThrobber");
        this.showModal("view-complex-service-modal");
      });        
  }

  removeServiceHandler(service: Service) {
    this.services.splice(this.services.indexOf(service), 1);
  }

  get billUrl() {
    if(this.bill)
    {
      return `/Patients/GenerateBills?patientId=${this.patientId}&userId=${this.$auth.user().id}&billId=${this.bill.id}`;
    }    
  }
}
